import type { QuestionSectionKind } from './editor/editorTypes';
import type { ComponentTimeline } from './hooks/useComponentTimeline';

/**
 * What the chapter page and Export to PDF both go by. In "view as student" the
 * role is the test student's, and the timeline is `useReaderTimeline`'s.
 */
export interface ChapterReader {
  isInstructionalView: boolean;
  timeline: ComponentTimeline;
}

export function isLessonContentShown({ isInstructionalView, timeline }: ChapterReader) {
  return isInstructionalView || timeline.isContentVisible;
}

// A closed set stays readable, whatever its visibility says.
export function isQuestionSectionShown(
  kind: QuestionSectionKind,
  { isInstructionalView, timeline }: ChapterReader,
) {
  if (isInstructionalView) {
    return true;
  }

  return kind === 'preLecture'
    ? timeline.isPreLectureVisible || timeline.isPreLectureClosed
    : timeline.isHomeworkVisible || timeline.isHomeworkClosed;
}
